import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import EmailQuote from 'pu-react/components/EmailQuoteValidates';
import PriceCombined from "./PriceCombined";

import PricePlx from './PricePlx'

import { priceSelected, doEmailQuote } from '../fabricationSlice';

const Price = (props) => {
  const dispatch = useDispatch();
  const {
    quote,
    usCombined,
    quoteStep,
    parameters,
    parametersCustomer,
    parametersBestPrice,
    parametersChanged,
  } = useSelector((state) => state.fabrication)

  const onPriceSelect = (data) => dispatch(priceSelected(data));
  const onSendEmailQuote = (data, token) => dispatch(doEmailQuote({ data, token }));

  if (!usCombined || !usCombined.matrix) return null;

  return (
    <div className="card border-0 mb-4">
      <div className="text-end p-3 pb-0">
        <EmailQuote
          quoteStep={quoteStep}
          parametersChanged={parametersChanged}
          parameters={parameters}
          onSendEmailQuote={onSendEmailQuote} />
      </div>

      <PricePlx
        quote={quote}
        parametersChanged={parametersChanged}
        onPriceSelect={onPriceSelect}
        parameters={parameters}
        quoteStep={quoteStep} />
      <hr className="my-0 mx-3 mb-2" />
      <PriceCombined
        usCombined={usCombined}
        quoteStep={quoteStep}
        onPriceSelect={onPriceSelect}
        parametersChanged={parametersChanged}
        parameters={parameters} />

      <div className="card-body pt-0 pricing-notes">
        <ul className="ps-3">
          <li>Prices are per board for the Quantity and Lead Time Days quoted.</li>
          <li>Lead Time Days are business days until the order ships, does not include transit time or cost.</li>
          <li>The next business day is Day 1.</li>
        </ul>
        <hr />
        <strong className="versus-title">ONLINE VERSUS CUSTOM QUOTE</strong>
        <div className="row mt-2">
          <div className="col-lg-6">
            <strong>Online Quote</strong>
            <p>
              Receive an instant quote <br />
              Low quantities (prototype and short run)<br />
              Min trace/space = 5 mils<br />
              Min drill size = 8 mils<br />
            </p>
          </div>
          <div className="col-lg-6">
            <strong>Custom Quote</strong>
            <p>
              Receive a quote within 24 hours<br />
              Any quantity<br />
              Advance features (control impedance, counter hole,
              counter sink, via in pad, blind vias, buried vias)<br />
            </p>
          </div>
        </div>
        <div className="mt-2">
          If you cannot get an online quote request a
          {' '}
          <a
            className="text-decoration-underline"
            href="/custom_quote_request">
            custom quote
          </a>
          .
        </div>
      </div>
    </div>
  );
}

export default Price;
